export type FrontendErrorsPreset = "1h" | "24h" | "7d";

export type FrontendErrorsRange = { from: number; to: number };

const HOUR_MS = 60 * 60 * 1000;
const DAY_MS = 24 * HOUR_MS;
const MAX_WINDOW_MS = 7 * DAY_MS;
const RETENTION_SAFE_MS = 29 * DAY_MS;
// The reader checks `from ≥ now − 29 d` with its own clock, a round-trip after ours: a floor placed exactly
// on the limit would be rejected by any skew or latency.
const RETENTION_MARGIN_MS = 5 * 60 * 1000;

const PRESET_MS: Record<FrontendErrorsPreset, number> = {
    "1h": HOUR_MS,
    "24h": DAY_MS,
    "7d": MAX_WINDOW_MS,
};

const presetRange = (preset: FrontendErrorsPreset, now: number): FrontendErrorsRange => ({
    from: now - PRESET_MS[preset],
    to: now,
});

const retentionFloor = (now: number): number => now - RETENTION_SAFE_MS + RETENTION_MARGIN_MS;

// Keeps the most recent part of the requested window; null when nothing of it is readable.
const clampRange = (range: FrontendErrorsRange, now: number): FrontendErrorsRange | null => {
    const floor = retentionFloor(now);
    const to = range.to;
    const from = Math.max(range.from, floor, to - MAX_WINDOW_MS);
    if (from >= to) return null;
    return { from, to };
};

export const frontendErrorsRange = {
    presetRange,
    clampRange,
    retentionFloor,
};
